/**
 * Team-weites CRM: alle Nutzer teilen dieselben Leads/Listen/Tasks.
 * Keine privaten crm_leads_u* Buckets mehr für die operative Sicht.
 */
import storage from '../services/storage';

export const TEAM_MIGRATION_FLAG = 'crm_team_store_migrated_v2';

export const TEAM_KEYS = {
  leads: 'crm_leads',
  lists: 'crm_lists',
  tasks: 'crm_tasks',
  meetings: 'crm_meetings',
  pipeline: 'crm_pipeline_stages',
  views: 'crm_team_views',
};

/** Immer Team-Key — userId wird ignoriert (Kompatibilität zu bestehenden Service-APIs). */
export function teamDataKey(baseKey, _userId) {
  void _userId;
  const map = {
    crm_leads: TEAM_KEYS.leads,
    crm_lists: TEAM_KEYS.lists,
    crm_tasks: TEAM_KEYS.tasks,
    crm_meetings: TEAM_KEYS.meetings,
    crm_pipeline_stages: TEAM_KEYS.pipeline,
  };
  return map[baseKey] || baseKey;
}

export function mergeRecordsById(a = [], b = [], idField = 'id') {
  const map = new Map();
  const ts = (row) => {
    const t = row?.updatedAt || row?.createdAt;
    const ms = t ? Date.parse(t) : 0;
    return Number.isFinite(ms) ? ms : 0;
  };
  for (const row of [...(Array.isArray(a) ? a : []), ...(Array.isArray(b) ? b : [])]) {
    if (!row || row[idField] == null) continue;
    const id = String(row[idField]);
    const prev = map.get(id);
    if (!prev || ts(row) >= ts(prev)) map.set(id, row);
  }
  return Array.from(map.values());
}

export function mergeLeadArrays(a = [], b = []) {
  return mergeRecordsById(a, b, 'id');
}

export function mergeListMeta(a = [], b = []) {
  return mergeRecordsById(a, b, 'id');
}

/** Liest alle crm_leads_u* und crm_lists_u* aus localStorage und vereinigt sie mit dem Team-Pool. */
export function migratePrivateBucketsToTeam() {
  if (storage.get(TEAM_MIGRATION_FLAG, false)) return { leads: 0, lists: 0, tasks: 0 };

  let teamLeads = storage.get(TEAM_KEYS.leads, []);
  let teamLists = storage.get(TEAM_KEYS.lists, []);
  let teamTasks = storage.get(TEAM_KEYS.tasks, []);
  let teamMeetings = storage.get(TEAM_KEYS.meetings, []);

  try {
    for (let i = 0; i < localStorage.length; i++) {
      const k = localStorage.key(i);
      if (!k) continue;
      if (k.startsWith('crm_leads_u')) {
        const chunk = storage.get(k, []);
        teamLeads = mergeLeadArrays(teamLeads, chunk);
      } else if (k.startsWith('crm_lists_u')) {
        teamLists = mergeListMeta(teamLists, storage.get(k, []));
      } else if (k.startsWith('crm_tasks_u')) {
        teamTasks = mergeRecordsById(teamTasks, storage.get(k, []));
      } else if (k.startsWith('crm_meetings_u')) {
        teamMeetings = mergeRecordsById(teamMeetings, storage.get(k, []));
      }
    }
  } catch { /* ignore */ }

  storage.set(TEAM_KEYS.leads, teamLeads);
  storage.set(TEAM_KEYS.lists, teamLists);
  storage.set(TEAM_KEYS.tasks, teamTasks);
  storage.set(TEAM_KEYS.meetings, teamMeetings);
  storage.set(TEAM_MIGRATION_FLAG, true);

  return {
    leads: teamLeads.length,
    lists: teamLists.length,
    tasks: teamTasks.length,
  };
}

export function ensureBuiltinLists(lists, leads) {
  const BASE = [{ id: 'all', label: 'Alle Leads' }, { id: 'top10', label: 'Top 10 Heute' }];
  let baseLists = BASE;
  const stored = Array.isArray(lists) ? lists : [];
  if (stored.length > 0) {
    const extra = stored.filter(s => !BASE.some(b => b.id === s.id));
    baseLists = [...BASE, ...extra];
  }
  const knownIds = new Set(baseLists.map(l => l.id));
  const orphanIds = [...new Set((leads || []).map(l => l.list).filter(id => id && !knownIds.has(id)))];
  const recovered = orphanIds.map(id => ({
    id,
    label: id.startsWith('import_') ? 'Importierte Liste' : id,
  }));
  return [...baseLists, ...recovered];
}
